import { render, staticRenderFns } from "./VeiculosForm.vue?vue&type=template&id=01478455&scoped=true&"
import script from "./VeiculosForm.vue?vue&type=script&lang=js&"
export * from "./VeiculosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01478455",
  null
  
)

export default component.exports